<span
    class="header-name"
    (click)="toggleExpanded()"
    >{{ params.name }}
    <i [class]="expandedIcon"></i>
</span>
